import { gql } from 'types/__generated__/gql';

const KEY_EXPORT_ORGANIZATION_CLASSROOM_REPORT_QUERY = gql(/* GraphQL */ `
  query getOrganizationClassroomReportExporting($id: Int!, $dateRange: DateRangeInput!) {
    organization: organization(where: { id: $id }) {
      id
      name
      type
      stats {
        classroomStudentCount
        userCount
        classroomCount
      }
      subOrganizations {
        type
      }
      licenseUsage(where: { productFamily: { code: "KEY" } }) {
        classroomAssignedCount
      }
    }
    activeStudents: keyActiveStudentsReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        activeStudentCount
        totalStudentCount
      }
    }
    activitiesCompleted: keyActivitiesCompletedReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        curriculumActivitiesCompleted {
          productCurriculumCode
          activitiesCompletedCount
        }
        totalActivitiesCompletedCount
      }
    }
    averageWeeklyTimeSpent: keyAverageWeeklyTimeSpentReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        curriculumAverageWeeklyTimeSpent {
          productCurriculumCode
          averageWeeklyMinutesSpent
        }
        averageWeeklyMinutesSpent
      }
    }
    curriculumProgress: keyCurriculumProgressReportAsync(where: { organizationId: $id }) {
      id
      error
      result {
        curriculumProgressPercentage
      }
    }
    classrooms: keyOrganizationClassroomEngagementReportAsync(
      where: { organizationId: $id }
      dateRange: $dateRange
    ) {
      id
      error
      result {
        ...BaseKeyboardingClassroomExport
        classroom {
          users {
            userId
            user {
              id
              username
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`);

export default KEY_EXPORT_ORGANIZATION_CLASSROOM_REPORT_QUERY;
